<template>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="showDialog"
        width="80%"
        :before-close="hideDialog"
        :center="false"
        :show-close="false"
        :append-to-body="true"
        >
        <span class="dialog-title clearfix" slot="title">
            <span>高级搜索</span>
            <el-button style="float: right" icon="el-icon-setting" @click="showSettingsDialog" type="primary">设置</el-button>
        </span>
        <el-row style="margin-bottom: 20px">
            <el-col :span="24" style="text-align: right">
                <el-select v-model="selectedSchemaID" @change="onSelectedSchemaChanged">
                    <el-option label="新方案" value="0"></el-option>
                    <el-option v-for="(item,index) in savedSearchSchemas" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form style="height: 400px; overflow: scroll" ref="form" :model="searchParams" label-width="150px" label-position="left">
                    <el-form-item v-for="(item,index) in currentSearchSchema.cols" :key="index" :label="item.value + ( item.unit ? '(' + item.unit + ')' : '')">
                        <el-select
                            v-if="item.type === 'select'"
                            v-model="searchParams[item.id]"
                            filterable
                            multiple
                            style="width: 100%">
                            <el-option v-for="option in item.options" :key="option" :label="option" :value="option"></el-option>
                        </el-select>
                        <el-select
                            style="width: 100%"
                            v-if="item.type === 'smart-select'"
                            v-model="searchParams[item.id]"
                            placeholder="请输入关键字"
                            filterable
                            allow-create
                            default-first-option
                            multiple
                            remote   
                            @focus="onFocusFunc(item.id)"
                            :remote-method="getSearchCandidatesFunc">
                            <template v-if="searchCandidates[item.id]">
                                <el-option v-for="item in searchCandidates[item.id]"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </template>
                        </el-select>
                        <el-date-picker
                            v-if="item.type === 'date-range'" 
                            v-model="searchParams[item.id]" 
                            type="monthrange">
                        </el-date-picker>   
                         <el-date-picker 
                            v-if="item.type === 'month-range'"
                            type="monthrange"
                            :picker-options="pickerOptions"
                            v-model="searchParams[item.id]">
                        </el-date-picker> 
                        <el-date-picker 
                            v-if="item.type === 'year-range'"
                            type="monthrange"
                            :picker-options="pickerOptions"
                            v-model="searchParams[item.id]">
                        </el-date-picker>
                          <el-date-picker 
                            v-if="item.type === 'year-pick'"
                            type="monthrange"
                           
                            v-model="searchParams[item.id]">
                        </el-date-picker>
                        <RangeSlider
                            v-if="item.type === 'number-range'"
                            v-model ="searchParams[item.id]" 
                            :value="searchParams[item.id]" 
                            :config="item">
                        </RangeSlider>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <span slot="footer">
            <!-- <p>{{searchParams}}</p>  -->
            <el-button @click="hideDialog">取消</el-button>
            <el-button @click="saveSearchSchema">保存为搜索方案</el-button>
            <slot  name="buttons"></slot>
            <el-button type="primary" @click="search">搜索</el-button>
        </span>
        <SearchSchema :showDialog.sync="showSettings" />
        <el-dialog title="方案名称"
            :visible.sync="showNameInput"
            :center="false"
            :append-to-body="true">
            <span slot="dialog-title"> </span>
            <el-input v-model="schemaName"></el-input>
            <span slot="footer">
                <el-button @click="hideNameInput">取消</el-button>
                <el-button @click="confirmNameInput" type="primary">保存</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import SearchSchema from '@/components/common/SearchSchema.vue';
import RangeSlider from '@/components/slider/RangeSlider.vue';
import ApiUrl from '../../store/apiurl';
import GUID from  '../../store/guid';
import { join } from 'path';
export default {
    components: {
        SearchSchema,
        RangeSlider,
    },
    props: {
        showDialog: Boolean
    },
    data() {
        return {
          pickerOptions: {
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          }, {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近二个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 2);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
            showNameInput: false,
            currentSmartSelectId:"all",
            schemaName: '',
            showSettings: false,
           // searchParams: {},
            expandedConditions: [],
            selectedConditions: [], // 置入的条件
            selectedSchemaID: "0",
            searchCandidates: {}
        }
    },
    methods: {
        ...mapActions('commonsearch', [
            'saveCurrentSearchSchema',
            'selectSavedSearchSchema',
            'initSavedSearchSchema',
            'doSearch',
        ]),
        ...mapMutations('commonsearch', [
            'clearCurrentSearchSchema','setSearchParams','setDefauleSearchSchema'
        ]),
        hideDialog() {
            this.$emit('update:showDialog', false);
        },
        // 隐藏名称输入
        hideNameInput() {
            this.showNameInput = false;
        },
        onSaved(res) {
            this.$message({
                message: res ? '已保存' : '保存失败',
                duration: 2000,   
            });
        },
        // 确认名次输入
        confirmNameInput() {
            if(this.schemaName) {
                var key = new GUID().newGUID();
                this.saveCurrentSearchSchema({schemaId:key, name: this.schemaName,action:'add', cb: this.onSaved });
                this.hideNameInput();
            }
        },
        // 搜索
        search() {
            this.doSearch(this.searchParams);
            this.hideDialog();
        },
        // 设置搜索条件
        showSettingsDialog() {
            this.showSettings = true;   
        },
        // 保存方案
        saveSearchSchema() {
            this.currentSearchSchema['searchParams'] = this.searchParams;
           // alert(JSON.stringify(this.searchParams));
            if(!this.currentSearchSchema.name) {
                this.showNameInput = true;
            } else {

                this.saveCurrentSearchSchema( {schemaId:this.currentSearchSchema.id, name:this.currentSearchSchema.name, action:'update', cb: this.onSaved } ,'search');
            }
        },
        onFocusFunc(opt){
          // alert(opt);
          this.currentSmartSelectId = opt;
         
        },
        // 获取联想
        async getSearchCandidatesFunc(query,str) {
         try {
            
              const resp =  await this.$axios.post(ApiUrl.salesanalysis.getsmartsearchkeyword,{id:this.currentSmartSelectId,keyword:query});       
                 console.log(resp);         
                this.timeout && clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                  //  console.log(resp.data.result);
                 //   cb(resp.data.result);
                  var keys =[];
                  for(var v in resp.data.result)
                  {
                      keys.push(resp.data.result[v].value);
                  }
                     this.$set(this.searchCandidates, this.currentSmartSelectId, keys);
                    // return (keyword) => { }
                    this.timeout = null;
                }, 1000);
            } catch(e) {
                console.log(e);
            }
         
           
        },
        // 方案选择变化
        onSelectedSchemaChanged(val) {
      
            if(val === '0') {
             //   this.clearCurrentSearchSchema();
             this.setDefauleSearchSchema();
            
            } else {
                this.selectSavedSearchSchema(val);           
                this.setSearchParams(this.currentSearchSchema.searchParams)  ;

            }
             
        },
         async loadAll() {
        
            await this.initSavedSearchSchema();
           // alert(JSON.stringify(this.searchSchema));
            
        }
    },
    computed: {
        ...mapGetters('commonsearch', [
            'currentSearchSchema',
            'savedSearchSchemas',
            'searchParams','searchSchema'
        ]),
    },
    watch: {
        searchParams: function(newVal){
            //console.log(newVal);
        },
        currentSearchSchema: function(newVal) {
                 
            let newParams = {}
            if(newVal && Array.isArray(newVal.cols)) {
                for(let k in this.searchParams) {
                    if(newVal.cols.findIndex((item) => { return item.id === k }) > -1) {
                        newParams[k] = this.searchParams[k];
                
                    }
                }
            }
            this.setSearchParams (newParams) ;    // ;
            if(newVal.id) {
                this.selectedSchemaID = newVal.id;
            } else {
                this.selectedSchemaID = '0';
            }
        },
    },
     mounted() {
       //   var key = new GUID().newGUID();
         //alert(key);
        this.loadAll();
    }
}
</script>

<style>
.dialog-title {
    text-align: left;
}
</style>

